<template>
<div class="chapter">
<div class="inner_page">
      ﻿


<meta charset="utf-8"/>
<link href="styles/custom.css" rel="stylesheet" type="text/css"/>
<title>Debt Bomb</title>
<section epub:type="copyright-page">
<p class="crt0"><span epub:type="pagebreak" id="page_ii" title="ii"><i>Debt Bomb</i></span></p>
<p class="crt1"> © 2021 Michael E. Ginsberg. All rights reserved.</p>
<p class="crt1"> No part of this book may be reproduced in any form or by any means, electronic, mechanical, digital, photocopying or recording, except for the inclusion in a review, without permission in writing from the publisher.</p>
<p class="crt1"> This is a work of fiction. All of the characters, names, incidents, organizations, and dialogue in this novel are either the products of the author’s imagination or are used fictitiously.</p>
<p class="crt1"> Published in the United States by BQB Publishing</p>
<p class="crt"> (an imprint of Boutique of Quality Books Publishing, Inc.) </p>
<p class="crt"><a href="http://www.bqbpublishing.com" target="_blank">www.bqbpublishing.com</a></p>
<p class="crt1"> Printed in the United States</p>
<p class="crt1"> ISBN 978-1-9527820-08-4 (p)</p>
<p class="crt"> ISBN 978-1-952782-09-1 (e)</p>
<p class="crt1"> Library of Congress Control Number: 2021935109</p>
<p class="crt1"> Book design by Robin Krauss, <a href="http://www.bookformatters.com" target="_blank">www.bookformatters.com</a></p>
<p class="crt"> Cover design by Rebecca Lown, <a href="http://www.rebeccalowndesign.com" target="_blank">www.rebeccalowndesign.com</a></p>
<p class="crt"> First editor: Caleb Guard</p>
<p class="crt"> Second editor: Andrea Vande Vorde</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// copyrightpage.vue?326023bf